// extracted by mini-css-extract-plugin
export default {"mergeTagsAddButton":"Fw5MmqbKbbIloUgJHo8a","popup":"StWjnWXw5UU0bFxmRlCv","showMoreButton":"HGpOFgv5TKV4yoVEcEZZ","showMoreButtonText":"_9bLPwgeVeNB9T8oapNO"};